import type { EditorialCategoryEntity } from '../generated/graphql'

export function findCategoryInCategoryList(
  categoryId: string | null,
  categoryList: EditorialCategoryEntity[]
) {
  return categoryList.find((category) => category.id === categoryId) ?? null
}
